import React, { useState } from 'react';
import { Button, Container, Grid, Paper, Typography, Box } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import LoginIcon from '@mui/icons-material/Login';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { NavLink } from 'react-router-dom';
import { useUserContext } from '../../context/UserContext';
import axios from 'axios';
import { useTheme } from '@mui/material/styles';
import GetStartedModal from '../GetStartedModal';

function HomepageHeroSection() {
    const { token } = useUserContext();
    const theme = useTheme();
    const [modalOpen, setModalOpen] = useState(false);

    const handleDownload = () => {
        axios({
            url: '/mobile/download',
            method: 'GET',
            responseType: 'blob',
        })
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const a = document.createElement('a');
                a.href = url;
                a.download = 'ehs-app-release.apk';
                document.body.appendChild(a);
                a.click();
                setTimeout(() => {
                    a.remove();
                    window.URL.revokeObjectURL(url);
                }, 100); // Delay cleanup to ensure download starts
            })
            .catch((error) => {
                alert('Failed to download the app. Please try again later.');
            });
    };

    return (
        <Container maxWidth="xl" sx={{ my: 5 }}>
            <Paper
                elevation={0}
                sx={{
                    px: '40px',
                    py: '10px',
                    borderRadius: '25px',
                    backgroundColor: theme.palette.common.white,
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                }}
            >
                <Grid container spacing={4} alignItems="center">
                    <Grid item xs={12} md={6}>
                        <Typography variant="h2" gutterBottom className="fancyTextSmall" fontWeight="500" color={theme.palette.common.white}>
                            Take Control of Your Home's Energy Today
                        </Typography>

                        <>
                            {!token && (
                                <Box sx={{
                                    mt: 3,
                                    mb: 3,
                                    p: 3,
                                    borderRadius: 3,
                                    background: 'linear-gradient(135deg, rgba(25,118,210,0.08) 0%, rgba(64,196,255,0.05) 100%)',
                                    border: '1px solid rgba(25,118,210,0.2)',
                                    boxShadow: '0 4px 20px rgba(25,118,210,0.1)',
                                    maxWidth: 500,
                                    mx: 'auto'
                                }}>
                                    <Typography variant="h6" sx={{
                                        textAlign: 'center',
                                        color: 'text.primary',
                                        fontWeight: 500,
                                        mb: 1
                                    }}>
                                        ✨ Ready to get started?
                                    </Typography>
                                    <Typography variant="body2" sx={{
                                        textAlign: 'center',
                                        color: 'text.secondary',
                                        lineHeight: 1.6,
                                        fontSize: '0.95rem',
                                        mb: 2
                                    }}>
                                        We'll help you set up your smart meter and connect your home to our energy management system.
                                    </Typography>

                                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                        <Button
                                            variant="contained"
                                            className="customButton"
                                            onClick={() => setModalOpen(true)}
                                            sx={{ textTransform: 'none', px: '50px' }}
                                            endIcon={<ArrowForwardIcon />}
                                        >
                                            I'm interested!
                                        </Button>
                                    </Box>
                                </Box>
                            )}
                        </>

                        {!token && (
                            <Button
                                variant="contained"
                                className="customButton"
                                component={NavLink}
                                to="/signin"
                                sx={{ textTransform: 'none', px: '50px', mt: 2, mx: 1 }}
                                endIcon={<LoginIcon />}
                            >
                                Sign In
                            </Button>
                        )}

                        <Button
                            variant="contained"
                            className="customButton"
                            onClick={handleDownload}
                            sx={{ textTransform: 'none', px: '50px', mt: 2, mx: 1 }}
                            startIcon={
                                <img
                                    src="/images/android_icon.png"
                                    alt="Android"
                                    style={{ width: 24, height: 24 }}
                                />
                            }
                            endIcon={<DownloadIcon />}
                        >
                            Download Android App
                        </Button>
                    </Grid>

                    <Grid item xs={12} md={6} className="imageContainer">
                        <img
                            src="/images/homepage_hero.png"
                            alt="Energy Control"
                            className="responsiveImage"
                        />
                    </Grid>
                </Grid>
            </Paper>

            <GetStartedModal
                open={modalOpen}
                onClose={() => setModalOpen(false)}
            />
        </Container >
    );
}

export default HomepageHeroSection;
